<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-sm-6">
                    <div class="card x_card no-bo">
                        <div v-if="isExpired" class="card-body">
                            <h3 class="text-center">This link will expire 24 hours. If you have question please contact to us.</h3>
                            <hr>
                            <div>
                                <div><b>CONTACT</b></div>
                                <div>Phone: 086-879-882</div>
                                <div>Email: bonvoath.tech@gmail.com</div>
                                <div>Telegram: @bonvoath.tech</div>
                            </div>
                        </div>
                        <div v-else class="card-body">
                            <h3 class="text-muted text-center">Please fill your personal information.</h3>
                            <div class="form-group">
                                <label class="label-control blue">Primary Email</label>
                                <input type="text" class="form-control" v-model="model.Email" readonly>
                            </div>
                            <div class="row">
                                <div class="col-md-6 form-group">
                                <label class="label-control blue">Client name</label>
                                <input type="text" class="form-control" v-model="model.Name">
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="label-control blue">Phone</label>
                                <input type="text" class="form-control" v-model="model.Phone">
                            </div>
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.UserName.$error }">
                                <label class="label-control blue">Username</label>
                                <input type="text" class="form-control" v-model="$v.model.UserName.$model">
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Password.$error }">
                                <label class="label-control blue">Password</label>
                                <input type="password" class="form-control" v-model="$v.model.Password.$model">
                                <ul v-if="$v.model.Password.$error" class="msg red">
                                    <li v-if="!$v.model.Password.minLength"><i class="fa fa-times red" aria-hidden="true"></i> Passwords must have at least 6 character.</li>
                                    <li v-if="!$v.model.Password.contain09"><i class="fa fa-times red" aria-hidden="true"></i> Passwords must have at least one non alphanumeric character.</li>
                                    <li v-if="!$v.model.Password.containaz"><i class="fa fa-times red" aria-hidden="true"></i> Passwords must have at least one lowercase (a-z).</li>
                                    <li v-if="!$v.model.Password.containAZ"><i class="fa fa-times red" aria-hidden="true"></i> Passwords must have at least one lowercase (A-Z).</li>
                                </ul>
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.ConfirmPassword.$error }">
                                <label class="label-control blue">Confirm Password</label>
                                <input type="password" class="form-control" v-model="$v.model.ConfirmPassword.$model">
                            </div>
                            <br>
                            <div class="form-group">
                                <button type="button" class="btn btn-success btn-block" @click="onSubmit">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import base from '../../shared/models/coreapi';
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
const contain09 = (value) => /[0-9]/.test(value);
const containaz = (value) => /[a-z]/.test(value);
const containAZ = (value) => /[A-Z]/.test(value);
export default {
    data() {
        return {
            isExpired: false,
            model: {
                Name: '',
                UserName: '',
                Password: '',
                ConfirmPassword: '',
                Phone: ''
            },
        }
    },
    validations: {
        model: {
            Name: {
                required,
                minLength: minLength(6)
            },
            UserName: {
                required,
                minLength: minLength(6)
            },
            Password: {
                required,
                minLength: minLength(6),
                contain09,containaz,containAZ
            },
            ConfirmPassword: {
                sameAsPassword: sameAs('Password')
            },
            Phone: { required }
        }
    },
    async created(){
        await this.getInfo();
    },
    methods: {
        async getInfo(){
            let loading = this.$loading.show();
            let res =  await base.api().post('client/confirm', { Text: this.$route.params.id });
            if(this.$isValid(res)){
                if(res.data.Json.IsExpired){
                    this.isExpired = true;
                }else{
                    this.model = res.data.Json.Client;
                }
            }
            loading.hide();
        },
        async onSubmit(){
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let loading = this.$loading.show();
                let res = await base.api().post('client/submit', this.model);
                if(this.$isValid(res)){
                    this.$router.push('/');
                }
                loading.hide();
            }
        }
    }
}
</script>
<style scoped>
    .red {
        color: red;
    }
    .msg{
        list-style-type: none;
        padding: 5px;
        margin: 0;
    }
</style>
